import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=adbc7e5a"
import script from "./EmojiPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports